<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>공지사항 관리</h2>
    </div>
    <div class="box one filter">
      <div class="flex">
        <p class="bold">검색조건</p>
        <select v-model="inputMode">
          <option value="" selected disabled>선택</option>
          <option value="title">제목</option>
          <option value="contents">내용</option>
        </select>
        <input type="text" v-model="searchWord" />
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>
    <div class="box one">
      <h2 class="bold">
        공지사항 리스트<button class="right basic">
          <router-link to="/admin/notice/register">공지사항 등록</router-link>
        </button>
      </h2>
      <table>
        <colgroup>
          <col style="width: 10%" />
          <col style="width: 25%" />
          <col style="width: 50%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>공지사항 제목</th>
          <th>공지사항 내용</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in noticeList" :key="i">
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              total + 1 - (i + 1 + (currentPage - 1) * 10)
            }}</router-link>
          </td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.title
            }}</router-link>
          </td>
          <td>{{ data.contents }}</td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <div class="pagination" v-if="noticeList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { fetchNoticeList } from "@/api/admin";
import { format } from "@/mixins/format";
import NoData from "@/components/contents/Nodata";
export default {
  mixins: [format],
  components: { NoData },
  name: "noticeManage",
  data() {
    return {
      moment: moment,
      loading: false,
      inputMode: "",
      searchWord: "",
      noticeList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "3");
  },
  mounted() {
    this.loading = true;
    this.getNoticeList();
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY년 MM월 DD일");
    },
    handleMove(id) {
      this.$router.push({ name: "noticeRegister", query: { id: id } });
    },

    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.noticeList = [];
      this.total = 0;
      this.currentPage = 1;
      this.getNoticeList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        return alert("검색 조건을 선택해 주세요.");
      }
      this.getNoticeList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNoticeList();
    },
    getNoticeList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        inputMode: this.inputMode,
      };
      fetchNoticeList(params).then((res) => {
        if (res.data.status == 200) {
          this.noticeList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
          this.loading = false;
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
  },
};
</script>
